const isTouchDevice = (): boolean =>
  window.matchMedia('(pointer: coarse)').matches;

export default isTouchDevice;
